<template>
  <div>
    <app-tooltip v-if="!showMore && text.length > limit" bottom>
      <template #activator="{ on }">
        <span v-on="on">
          <span>{{ shortText }}</span>
        </span>
      </template>
      <span>{{ text }}</span>
    </app-tooltip>

    <span v-else>
      <span>{{ text }}</span>
    </span>
    <span v-show="text.length > limit" class="link" @click.stop="showMore = !showMore">
      Show {{ showMore ? 'Less' : 'More' }}</span
    >
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    text: { type: String, required: true },
    limit: { type: Number, default: 10000 },
    tooltip: { type: Boolean, default: true }
  },
  data() {
    return {
      showMore: false
    }
  },
  computed: {
    shortText() {
      return _.truncate(this.text, { length: this.limit })
    }
  }
}
</script>
<style lang="scss" scoped>
.link {
  color: var(--v-anchor-base);
  cursor: pointer;
}
</style>
